if (!customElements.get('custom-product-gallery')) {
  customElements.define(
    'custom-product-gallery',
    class extends HTMLElement {
      connectedCallback() {
        this._slides = [...this.querySelectorAll('.cpg__slide')];
        this._thumbs = [...this.querySelectorAll('.cpg__thumb')];
        this._lightbox = this.querySelector('.cpg__lightbox');
        this._lightboxImg = this.querySelector('.cpg__lightbox-img');
        this._currentIndex = 0;
        this._thumbStrip = this.querySelector('.cpg__thumbs');

        this.querySelector('.cpg__thumb-arrow--prev')?.addEventListener('click', () => this._scrollThumbs(-1));
        this.querySelector('.cpg__thumb-arrow--next')?.addEventListener('click', () => this._scrollThumbs(1));

        this._thumbs.forEach((thumb, i) => {
          thumb.addEventListener('click', () => this._goTo(i));
        });

        this.querySelector('.cpg__arrow--prev')?.addEventListener('click', () => this._step(-1));
        this.querySelector('.cpg__arrow--next')?.addEventListener('click', () => this._step(1));

        this.querySelectorAll('.cpg__zoom-trigger').forEach((btn) => {
          btn.addEventListener('click', () => this._openLightbox(this._currentIndex));
        });

        if (this._lightbox) {
          this.querySelector('.cpg__lightbox-close')?.addEventListener('click', () => {
            this._lightbox.close();
          });

          this.querySelector('.cpg__lightbox-arrow--prev')?.addEventListener('click', () => {
            this._lightboxStep(-1);
          });
          this.querySelector('.cpg__lightbox-arrow--next')?.addEventListener('click', () => {
            this._lightboxStep(1);
          });

          this._lightbox.addEventListener('click', (e) => {
            if (e.target === this._lightbox) this._lightbox.close();
          });

          this._lightbox.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') this._lightboxStep(-1);
            else if (e.key === 'ArrowRight') this._lightboxStep(1);
          });
        }

        this.addEventListener('keydown', (e) => {
          if (this._lightbox?.open) return;
          if (e.key === 'ArrowLeft') this._step(-1);
          else if (e.key === 'ArrowRight') this._step(1);
        });
      }

      _scrollThumbs(direction) {
        if (!this._thumbStrip) return;
        const thumbWidth = this._thumbs[0]?.offsetWidth || 64;
        this._thumbStrip.scrollBy({ left: direction * (thumbWidth + 8) * 2, behavior: 'smooth' });
      }

      _goTo(index) {
        const count = this._slides.length;
        this._currentIndex = ((index % count) + count) % count;
        this._slides.forEach((s, i) => s.classList.toggle('cpg__slide--active', i === this._currentIndex));
        this._thumbs.forEach((t, i) => t.classList.toggle('cpg__thumb--active', i === this._currentIndex));
      }

      _step(delta) {
        this._goTo(this._currentIndex + delta);
      }

      _openLightbox(index) {
        if (!this._lightbox || !this._lightboxImg) return;
        this._lightboxIndex = index;
        this._updateLightboxImage();
        this._lightbox.showModal();
      }

      _lightboxStep(delta) {
        const count = this._slides.length;
        this._lightboxIndex = ((this._lightboxIndex + delta) % count + count) % count;
        this._updateLightboxImage();
        this._goTo(this._lightboxIndex);
      }

      _updateLightboxImage() {
        const slide = this._slides[this._lightboxIndex];
        if (!slide || !this._lightboxImg) return;
        this._lightboxImg.src = slide.dataset.src || '';
        this._lightboxImg.alt = slide.dataset.alt || '';
      }
    }
  );
}
